import { Component, inject, OnInit } from '@angular/core';
import { PageHeaderComponent } from '../../components/page-header/page-header.component';
import { Router, RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { ContractComponent } from '../../components/contract/contract.component';
import { Contract } from '../../interfaces/contract';
import { DashboardService } from './dashboard.service';
import { BaseComponent } from '../../components/base.component';
import { LoadingService } from '../../services/loading.service';
import { ActiveContractsResponse } from '../../interfaces/responses';

@Component({
    selector: 'mobilize-dashboard',
    imports: [
        PageHeaderComponent,
        ContractComponent,
        RouterLink,
        NgClass
    ],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent extends BaseComponent implements OnInit {

    private _router = inject(Router);
    private _dashboard = inject(DashboardService);
    private _loading = inject(LoadingService);

    contracts: Contract[] = [];
    unpaidAmount = 0;
    extraPaidAmount = 0;
    overdue = false;
    allCredits = false;

    constructor() {
        super();
        this._loading.setLoadingState(true);
    }

    goToDocuments(doc?: string) {
        if (doc) {
            this._router.navigateByUrl('generate-document', {state: {data: {doc}}});
        } else {
            this._router.navigateByUrl('generate-document');
        }
    }

    ngOnInit() {
        this._dashboard.getDashboardContracts().subscribe((rsp: ActiveContractsResponse) => {
            this.contracts = rsp.data;
            this.allCredits = this.contracts.every(item => item.contract_type === 'Credit');
            this.contracts.forEach((item: Contract, idx: number) => {
                if (item.overdue_invoices_ron > 0) {
                    this.overdue = true;
                }
                if (idx === 0) {
                    item.contract_extended_state = 'opened';
                } else {
                    item.contract_extended_state = 'closed';
                }
                item.extendable = true

                this.unpaidAmount += parseFloat(item.unpaid_invoices_ron);
            });

            this.extraPaidAmount = rsp.total_advance;

            this._loading.setLoadingState(false);
        });
    }

    pay() {
        this._router.navigateByUrl('/pay');
    }
}
